import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import Heading from '../../components/Heading';
import ReportsIcon from '../../styles/svg/reports.svg';
import './reports.scss';
import HeadingTitle from '../../components/HeadingTitle';
import SpreadsheetAnnualNotice from './components/SpreadsheetAnnualNotice';
import NoAccessNotice from './components/NoAccessNotice';
import BuildingComplianceReport from './components/BuildingComplianceReport';
import PropertyServiceReport from './components/PropertyServiceReport';
import axios from 'axios';
import AffidavitForMailing from './components/AffidavitForMailing';
import AnnualComplianceSignUpReport from './components/AnnualComplianceSignUpReport';
import AnnualNoticeSummaryForm from './components/AnnualNoticeSummaryForm';

const Reports = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // In a real application, you would fetch clients from your API
    // This is just a placeholder for demonstration
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setClients([
        { id: 1, name: 'Client 1' },
        { id: 2, name: 'Client 2' },
        { id: 3, name: 'Client 3' }
      ]);
      setLoading(false);
    }, 500);
    
    // In a real app, you would use:
    // const fetchClients = async () => {
    //   try {
    //     const response = await axios.get('/api/clients');
    //     setClients(response.data);
    //   } catch (error) {
    //     console.error('Error fetching clients:', error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    // fetchClients();
  }, []);

  const handleClientNoticeReport = async (clientId) => {
    // In a real application, you would fetch the client's no access data
    // and generate the report based on that data
    console.log(`Generating report for client ${clientId}`);
  };

  return (
    <div className="reports-container">
      <Heading title="Reports" icon={ReportsIcon} />

      <Grid container spacing={3} className="mt-0" alignItems="stretch">
        {/* Outstanding Annual Notices - Mailing Addresses */}
        <Grid item xs={12} md={6}>
          <HeadingTitle
            title="Outstanding Annual Notices - Mailing Addresses"  
            style={{ height: "100%" }}
          >
            <SpreadsheetAnnualNotice />
          </HeadingTitle>
        </Grid>

        {/* No Access Notice */}
        <Grid item xs={12} md={6}>
          <HeadingTitle title="No Access Notice" style={{ height: "100%" }}>
            <NoAccessNotice
              handleClientNoticeReport={handleClientNoticeReport}
              isLoading={loading}
            />
          </HeadingTitle>
        </Grid>

        {/* Building Compliance Report - Annual Notices */}
        <Grid item xs={12} md={6}>
          <HeadingTitle
            title="Building Compliance Report - Annual Notices"
            style={{ height: "100%" }}
          >
            <BuildingComplianceReport />
          </HeadingTitle>
        </Grid>

        {/* Client Property & Service Matrix */}
        <Grid item xs={12} md={6}>
          <HeadingTitle
            title="Client Property & Service Matrix"
            style={{ height: "100%" }}
          >
            <PropertyServiceReport />
          </HeadingTitle>
        </Grid>

        {/* Affidavit for mailing */}
        <Grid item xs={12} md={6}>
          <HeadingTitle title="Affidavit of Mailing" style={{ height: "100%" }}>
            <AffidavitForMailing />
          </HeadingTitle>
        </Grid>

          {/*Annual Compliance Sign up Report*/}
          <Grid item xs={12} md={6}>
          <HeadingTitle
            title="Annual Compliance Sign up Report"
            style={{ height: "100%" }}
          >
            <AnnualComplianceSignUpReport />
          </HeadingTitle>
        </Grid>

        <Grid item xs={12} md={6}>
          <HeadingTitle
            title="Delivery of Annual Notice Summary Form"
            style={{ height: "100%" }}
          >
            <AnnualNoticeSummaryForm />            
          </HeadingTitle>
        </Grid>
      </Grid>
    </div>
  );
};

export default Reports; 